import { useTranslation } from 'react-i18next';

import {
  ItemCard,
  ItemCardDivider,
  ItemCardFooter,
} from '@sola/ark-core/molecules/item-card/item-card.js';
import { NumberField } from '@sola/ark-core/molecules/number-field/number-field.js';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.js';

import { CommitmentCardInfoSection } from '../commitment-card-info-section/commitment-card-info-section.js';

export const CommitmentCardPayment: React.FC<{
  commitment: GraphQLCommitment;
  hintText?: string;
}> = ({ commitment, hintText }) => {
  const { t } = useTranslation(['my', 'core']);
  const amountMinLimitMsg = t('core:forms.errors.amountLimitsMin', {
    min: 0,
  });

  return (
    <ItemCard>
      <CommitmentCardInfoSection commitment={commitment} />
      <ItemCardDivider />
      <ItemCardFooter justify="between">
        <div>
          <NumberField
            name={commitment.internalId}
            prefix="$"
            label="Enter payment amount"
            placeholder="0.00"
            step="1"
            min={{
              value: 0,
              message: amountMinLimitMsg,
            }}
          />
          {hintText && (
            <p className="mt-snug-lg label-mild label-md label-neutral-moderate">
              {hintText}
            </p>
          )}
        </div>
      </ItemCardFooter>
    </ItemCard>
  );
};
